import React, { useEffect } from "react";
import { Landing } from "./pages/Landing";
import { initializeMetaPixel } from "./utils/metaPixel";
const PAGE_TITLE = "Team Communication Ready - Complete Guide";
const PAGE_DESCRIPTION = "Five planned 30-minute team communication workshops with facilitator scripts, role cards and five bonus PDFs. Complete facilitator guide. $27 USD, one time.";
export function App() {
  useEffect(() => {
    initializeMetaPixel();
    document.title = PAGE_TITLE;
    document.documentElement.lang = "en-US";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <Landing data-id="element-0" data-mp="28tw5arkn8k3g" />;
}